export default __webpack_public_path__ + "static/media/x.b2879c6a.svg";